var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 14,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53893 8.47019C3.89442 8.82568 4.46867 8.82568 4.82415 8.47019L11.7334 1.55184C12.0889 1.19635 12.0889 0.622104 11.7334 0.266616C11.3779 -0.088872 10.8036 -0.088872 10.4482 0.266616L4.17698 6.53779L1.55184 3.91265C1.19635 3.55716 0.622104 3.55716 0.266616 3.91265C-0.088872 4.26814 -0.088872 4.84238 0.266616 5.19787L3.53893 8.47019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.8318a4e7500689b58ba5a47eec4a55de.svg";
export { ForwardRef as ReactComponent };